import { APP_TIMEZONE } from '../constants/formInitialStates';

export const PHARMACY_HANDOVER_REQUEST_EVENT = 'pharmacy-handover-request';
export const PHARMACY_HANDOVER_RESPONSE_EVENT = 'pharmacy-handover-response';

export const getAppDateString = (value = new Date()) =>
    new Intl.DateTimeFormat('en-CA', {
        timeZone: APP_TIMEZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(new Date(value)).replace(/\//g, '-');
